const transferModal = {
  'transfer-modal-transfer': 'Transferir',
  'transfer-modal-select': 'Selecionar',
  'transfer-modal-amount-value': 'Qual valor deseja transferir?',
  'transfer-modal-card-select': 'Para qual conta você deseja transferir?',
  'transfer-modal-check-data': 'Confira os dados da sua transação',
  'transfer-modal-confirm': 'Confirmar',
  'transfer-modal-of': 'Transferência de',
  'transfer-modal-to': 'para',
  'transfer-modal-success': 'Transferência realizada com sucesso',
  'transfer-modal-error': 'Não foi possivel realizar a transferência',
  'transfer-modal-nocards': 'Nenhuma conta encontrada para transferência',
};

export default transferModal;
